<!--董事会-->
<template>
  <div class="content_width_box">
      <div class="content_title">
        <div class="title_left_h2">常见问题</div>
      </div>
      <div class="content_list_layout">
          <div class="question_layout">
            <div class="question_list_box" @click="answer1=!answer1">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司位于哪里？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            
            <Collapse>
              <div class="answer_box" v-show="answer1">
                <div>金山软件有限公司总部位于香港，并且在北京、珠海、武汉、成都、大连及香港等多地分设研发中心。</div><br>
                <div>公司位于香港的地址为：</div>
                <div>香港九龙尖沙咀海港城港威大厦第5座32楼3208室</div>
                <div>电话: ( 852 ) 98303138 ( 手机 )&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;( 852 ) 24050088 ( 座机 )</div><br>
                <div>公司位于北京的地址为：</div>
                <div>北京市海淀区西二旗中路33号 小米科技园D栋</div>
                <div>邮编: 100085</div>
                <div>电话: 8610 82335515</div>
                <div>传真: 8610 82325655</div>
              </div>
            </Collapse>
          </div>
          <div class="question_layout">
            <div class="question_list_box" @click="answer2=!answer2">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司在哪里上市？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            <Collapse>
              <div class="answer_box" v-show="answer2">
                <div>公司在香港联交所上市，股票代码3888。</div>
              </div>
            </Collapse>
            
          </div>
          <div class="question_layout">
            <div class="question_list_box" @click="answer3=!answer3">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司首次公开上市是什么时间？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            <Collapse>
              <div class="answer_box" v-show="answer3">
                <div>2007年10月9日。</div>
              </div>
            </Collapse>
            
          </div>
          <div class="question_layout">
            <div class="question_list_box" @click="answer4=!answer4">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司每个财年截止何时？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            <Collapse>
              <div class="answer_box" v-show="answer4">
                <div>截至每年十二月月末。</div>
              </div>
            </Collapse>
            
          </div>
          <div class="question_layout">
            <div class="question_list_box" @click="answer5=!answer5">
              <div class="question_q">
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司的独立审计师是谁？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            <Collapse>
              <div class="answer_box" v-show="answer5">
                <div>香港安永会计师事务所。</div>
              </div>
            </Collapse>
            
          </div>
          <div class="question_layout">
            <div class="question_list_box" @click="answer6=!answer6">
              <div class="question_q" >
                <i class="iconfont icon-website-wenda"></i>
                <div class="question_title">金山软件有限公司的香港合规法律顾问是谁？</div>
              </div>
              <i class="iconfont icon-website-jiahao" ></i>
            </div>
            <Collapse>
              <div class="answer_box" v-show="answer6">
                <div>贝克•麦坚时律师事务所。</div>
              </div>
            </Collapse>
            
          </div>
          
        </div>

    </div>
</template>
<script>
import Collapse from '../../utils/expansion.js'
export default {
    name: 'investorQuestions',
    components:{Collapse},
    created(){
        
    },
    data () {
      return {
        answer1:false,
        answer2:false,
        answer3:false,
        answer4:false,
        answer5:false,
        answer6:false,
      }
    },
    computed:{
      
    },
    methods:{
      clickCol(){
        this.boxshow = !this.boxshow
      }
    }
}


</script>


